<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';

  interface Props {
    nav: VerticalNavType;
    active?: boolean;
    hasCount?: boolean;
    countMap?: any;
    onclick?: (e: MouseEvent) => void;
    children?: import('svelte').Snippet;
  }

  let {
    nav,
    active = false,
    hasCount = false,
    countMap = {},
    onclick,
    children
  }: Props = $props();

  let hasChildren = $derived(nav.children && nav.children.length !== 0);
  let navCount = $derived(nav.count || 0);

  const getIconColor = (active: boolean): string => {
    const arrow = active ? 'icon-chevron-down' : 'icon-chevron-right';
    return `${arrow}`.trim();
  };

  // const applyCenterEllipses = (text: string): string => {
  //   if (text.length <= 20) {
  //     return text;
  //   }
  //   return `${text.slice(0, 10)}...${text.slice(-10, text.length)}`;
  // };
</script>

<div class="vnav-i" class:active={active && !hasChildren} class:hasCount>
  <button
    data-cy={nav.id}
    type="button"
    class="label"
    class:highlightCount={nav?.highlightCount}
    {onclick}
  >
    <div class="text">
      <div data-cy="menu-label" class="text-value">{nav.label}</div>
      {#if hasCount && (typeof countMap[nav.id] === 'number' || navCount)}
        <div data-cy="menu-count" class="text-count">{countMap[nav.id] || navCount}</div>
      {/if}
      {#if nav.icon}
        <div data-cy="nav-icon" class="nav-icon"><Icon value={nav.icon} /></div>
      {/if}
    </div>
    {#if hasChildren || nav.hasChildPage}
      <div class="icon">
        {#if nav.hasChildPage && active}
          <Spinner />
        {:else}
          <Icon value={getIconColor(active)} />
        {/if}
      </div>
    {/if}
  </button>
  {#if hasChildren}
    <div class="children-wrap" class:show={active}>
      {@render children?.()}
    </div>
  {/if}
</div>

<style>
  .vnav-i .label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    padding: 0 12px;
    line-height: 1;
    border-radius: 5px;
    font-weight: 500;
    font-size: 14px;
    color: var(--grey-medium);
    text-align: left;
  }
  .vnav-i .label.highlightCount {
    padding: 0 8px 0px 12px;
  }
  .vnav-i .label.highlightCount .text .text-count {
    background-color: var(--yellow);
    padding: 3px 6px;
    border-radius: 4px;
  }
  .vnav-i .label .text {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .vnav-i .label .text .text-value {
    width: 90%;
    line-height: 36px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
  }
  .text-count {
    margin-left: 4px;
  }
  .vnav-i .label:hover {
    background-color: var(--grey-bg);
  }
  .vnav-i.active > .label {
    background-color: var(--light-blue);
    color: var(--blue);
  }
  .vnav-i.hasCount .label {
    position: relative;
  }
  .vnav-i.hasCount .label .icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(-100%, -50%);
  }

  .children-wrap {
    width: 100%;
    display: none;
  }
  .children-wrap.show {
    display: flex;
    flex-direction: column;
  }
  .nav-icon {
    display: inline-flex;
    align-items: center;
  }
</style>
